import React from "react";
import { classNames } from "../../helpers/classNames";

const Switch = ({
  checked,
  onChange = () => {},
  className = "",
  name,
  disabled = false,
}) => {
  return (
    <>
      <div className="relative overflow-hidden flex items-center">
        <input
          name={name}
          type="checkbox"
          className={`peer absolute top-0 left-0 z-10 opacity-0 w-full bl h-full ${
            !disabled ? "cursor-pointer" : "cursor-default"
          }`}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <div
          className={classNames(
            "w-12 h-6 rounded-3xl border border-shades-05/20 bg-shades-04 transition-all duration-200",
            "before:absolute before:content-[''] before:top-1/2 before:left-0.5 before:-translate-y-1/2 before:bg-white before:w-5 before:h-5 before:rounded-full before:transition-all duration-200 before:shadow",
            "peer-checked:before:left-[26px] peer-checked:bg-chestnut-rose peer-checked:border-chestnut-rose peer-checked:before:bg-white",
            disabled ? "opacity-60" : "",
            className
          )}
        ></div>
      </div>
    </>
  );
};

export default Switch;
